import {
  arrayBufferDownloadExcel,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
} from "../../../../utils/table/gridUtils";
import {
  FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST,
  FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT,
  EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK,
  TOAST,
  SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
  CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS,
} from "../../../types/Reservations/ReservationsByLocationAndNetwork.type";
import { getCurrentAndThreeDaysLater } from "../../../../utils";

const getDefaultFilters = () => {
  const { currentDate, threeDaysLater } = getCurrentAndThreeDaysLater();
  return {
    startDate: currentDate,
    endDate: threeDaysLater,
    location: "",
    network: "",
  };
};

const INITIAL_STATE = {
  ReservationsByLocationAndNetworkListview: [],
  isLoading: false,
  error: null,
  isExportSuccess: false,
  isExportError: false,
  filters: getDefaultFilters(),
};

const transformToGridView = (data) => {
  const rows = [];

  if (data?.report) {
    data.report.forEach((location) => {
      location.networks.forEach((network) => {
        const transformedValues = {
          locationName: location.location_name,
          networkName: network.network_name,
          confirmed: network.confirmed,
          cancelled: network.cancelled,
          noShow: network.no_show,
          total: network.total,
        };
        const decoratedValues = {};
        Object.keys(transformedValues).forEach((key) => {
          decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
        });
        rows.push(decoratedValues);
      });
    });
  }

  const columns = [
    {
      colLabel: "Location",
      dataKey: "locationName",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
    {
      colLabel: "Network",
      dataKey: "networkName",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
    {
      colLabel: "Confirmed",
      dataKey: "confirmed",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
    {
      colLabel: "Cancelled",
      dataKey: "cancelled",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
    {
      colLabel: "No Show",
      dataKey: "noShow",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
    {
      colLabel: "Total",
      dataKey: "total",
      extraProps: {
        isSortable: false,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
      },
    },
  ];

  return { columns, rows };
};

export const ReservationsByLocationAndNetworkReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_INIT:
      return { ...INITIAL_STATE, isLoadingPage: false };

    case FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.START:
      return { ...state, isLoading: true };

    case FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.SUCCESS: {
      const data = action.payload;

      if (!data?.report) {
        return {
          ...state,
          ReservationsByLocationAndNetworkListview: [],
          paginationInfo: null,
          isLoading: false,
          isLoadingPage: false,
        };
      }

      const { columns, rows } = transformToGridView(data);

      return {
        ...state,
        ReservationsByLocationAndNetworkListview: { columns, rows },
        paginationInfo: {
          pageSize: data.page_size,
          totalRecords: data.total_locations,
          totalPages: Math.ceil(data.total_locations / data.page_size),
          pageNumber: data.page,
        },
        totals: data.totals,
        isLoading: false,
        isLoadingPage: false,
        error: null,
      };
    }

    case FETCH_RESERVATIONS_BY_LOCATION_AND_NETWORK_LIST.ERROR: {
      return {
        ...state,
        ReservationsByLocationAndNetworkListview: [],
        isLoading: false,
        isLoadingPage: false,
        error: action.payload?.error,
        isPageLevelError: true,
      };
    }

    case EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.START:
      return { ...state, isLoading: true };

    case EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.SUCCESS: {
      arrayBufferDownloadExcel(action.payload, "reservations-by-location-and-network.xlsx");
      return {
        ...state,
        isLoading: false,
        isExportSuccess: true,
        isExportError: false,
      };
    }

    case EXPORT_RESERVATIONS_BY_LOCATION_AND_NETWORK.ERROR: {
      return {
        ...state,
        isLoading: false,
        isExportSuccess: false,
        isExportError: true,
      };
    }

    case TOAST.RESET: {
      return {
        ...state,
        isExportSuccess: false,
        isExportError: false,
      };
    }

    case SET_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS: {
      return {
        ...state,
        filters: action.payload,
      };
    }

    case CLEAR_RESERVATIONS_BY_LOCATION_AND_NETWORK_FILTERS: {
      return {
        ...state,
        filters: getDefaultFilters(),
      };
    }

    default:
      return state;
  }
};
